import { Placement, PlacementType } from '@noths/polaris-client-ribbons-design-system';
import { createSlice, SerializedError } from '@reduxjs/toolkit';

import { SimilarProduct } from 'src/types';
import { requestSimilarProducts } from './thunks';

const defaultPlacement = { products: [] as SimilarProduct[] };

export interface RichRelevanceState extends PlacementType<SimilarProduct> {
  errors: SerializedError[] | null;
}

export const initialState: Readonly<RichRelevanceState> = {
  errors: null,
  [Placement.RecentlyViewed]: defaultPlacement,
  [Placement.OutOfStock]: defaultPlacement,
  [Placement.ActiveProducts]: defaultPlacement,
  [Placement.SameSeller]: defaultPlacement,
  [Placement.AddToCart]: defaultPlacement,
  [Placement.HomePageRecentlyViewed]: defaultPlacement,
  [Placement.SameSeller]: defaultPlacement,
};

export const { actions, reducer } = createSlice({
  name: 'richRelevance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestSimilarProducts.fulfilled, (state, { payload }) => {
        if (payload && payload.placementType) {
          state[payload.placementType] = {
            placementTitle: payload.placementTitle,
            placementStrategy: payload.placementStrategy,
            products: payload.products.length > 0 ? payload.products : null,
          };
        }
      })
      .addCase(requestSimilarProducts.rejected, (state, action) => {
        if (action.payload?.error) {
          state.errors = state.errors
            ? state.errors.concat([action.payload.error])
            : [action.payload.error];
        }

        if (action.payload?.placementType) {
          state[action.payload.placementType] = {
            products: null,
          };
        }
      });
  },
});
